import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/transport-plan/insert',
        method: 'post',
        data: { ...row, planType: 1 }
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/transport-plan/update',
        method: 'post',
        data: row
    })
}

/** 铁运合同拆分月计划：仅改计划量，后续月份按比例调整 */
export const updateRailContractMonthWeight = (id, planTotalWeight) => {
    return request({
        url: '/api/produce/transport-plan/update/rail-contract-month-weight',
        method: 'post',
        data: { id, planTotalWeight }
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/transport-plan/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/transport-plan/select/page',
        method: 'get',
        params
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/transport-plan/month/export',
        method: 'get',
        params,
        responseType: 'blob'
    })
}
export const remove = (ids) => {
    return request({
        url: '/api/produce/transport-plan/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}

export const getContractExtpage = (params) => {
    return request({
        url: '/api/produce/transport-contract-ext/select/contractExtpage',
        method: 'get',
        params
    })
}
export const getContractList = (params) => {
    return request({
        url: '/api/produce/transport-contract-ext/select/contractExtpage',
        method: 'get',
        params
    })
}
 
